<template>
  <div class="white-background-section">
    <div class="container">
      <el-row>
        <div class="involve-heading-text mt-5">
          <div class="involve-data">
            <div>
              <el-col class :md="24" :lg="12">
                <div class="left-text">
                  <h1 class="involve-title">{{text.heading}}</h1>
                  <p class="involve-sub-text first-sub">{{text.sub_1}}</p>
                  <p class="involve-sub-text first-sub">{{text.sub_2}}</p>
                  <p class="involve-sub-text">{{text.listStart}}</p>
                  <div class>
                    <ul class="involve-list">
                      <li v-for="point in bulletPoints" :key="point.text">{{ point.text }}</li>
                    </ul>
                  </div>
                </div>
              </el-col>
            </div>
            <div>
              <el-col :md="24" :lg="12">
                <div class="invlove-img mt-4">
                  <img  alt="" class src="../../../../static/img/radred.png" />
                </div>
              </el-col>
            </div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: {
        heading: "What's involved?",
        sub_1: "We know you’re busy and want to offer the most value with the time that you have.",
        sub_2: "Choose who to help, the level of support that you offer and how long you commit.",
        listStart: "You could support companies with :"
      },
      bulletPoints: [
        { text: "Business development or leadership advice" },
        { text: "Insight on your sector or geographic market" },
        { text: "Meeting companies face-to-face" },
        { text: "Organising meetings between Scottish companies and your connections"},
        { text: "Finding suppliers, distributors and customers abroad" }
      ]
    };
  }
};
</script>
<style>
.invlove-img {
/*  margin-bottom: 50px;*/
}
.left-text {
  margin-bottom: 50px;
}
</style>
